import $ from 'jquery';

const bindForm = function bindForm({ $form }) {
  const url = $form.attr('action');
  const redirectUrl = $form.data('redirect');
  const $formErrors = $('#sylius-cart-validation-error');

  $form.api({
    method: 'POST',
    on: 'submit',
    cache: false,
    url,
    beforeSend(settings) {
      /* eslint-disable-next-line no-param-reassign */
      settings.data = $form.serialize();

      return settings;
    },
    onSuccess() {
      $formErrors.addClass('hidden');
      window.location.href = redirectUrl;
    },
    onFailure(response) {
      $formErrors.removeClass('hidden');
      let validationMessage = '';

      Object.entries(response.errors.errors).forEach(([, message]) => {
        validationMessage += message;
      });
      $formErrors.html(validationMessage);
      $form.removeClass('loading');
    },
  });
};

$.fn.extend({
  addToCartDirect() {
    const $productList = this;

    $productList.on('click', '.add-to-cart.button', (evt) => {
      const $button = $(evt.currentTarget);
      const $productItem = $button.closest('.product');
      const $form = $productItem.find('form.add-to-cart-direct');

      bindForm({ $form });
      $form.submit();
    });
  },
});
